import { RecordStandardGroup } from "@/api/record";

const Standard: Record<number, string> = {
  [RecordStandardGroup.API]: "API 1104",
  [RecordStandardGroup.AS]: "AS",
  [RecordStandardGroup.ASME]: "ASME IX",
  [RecordStandardGroup.AWSD1_1]: "AWS D1.1",
  [RecordStandardGroup.AWSD17_1]: "AWS D17.1",
  [RecordStandardGroup.DOT]: "DOT",
  [RecordStandardGroup.ISO]: "ISO",
  [RecordStandardGroup.PED]: "PED",
  [RecordStandardGroup.WAPI]: "API 1104",
};

export function getStandardName(standard: RecordStandardGroup) {
  return Standard[standard];
}
